<template>
  <Modal name="CREATE_UPDATE_PARTNER_MODAL" :title="title" :width="600" actions>
    <template v-slot:body>
      <v-form ref="partnerForm" v-model="valid" lazy-validation>
        <v-text-field
          v-model="name"
          @keydown.enter.prevent="validate"
          :label="$t('partner.label.name')"
          :rules="rules.required"
          :loading="isLoading"
          ref="partnerNameInput"
          hide-details="auto"
          outlined
        />

        <v-spacer class="my-4" />

        <v-textarea
          v-model="description"
          :label="$t('partner.label.description')"
          :loading="isLoading"
          hide-details="auto"
          text-area
          outlined
        />

        <v-spacer class="my-4" />

        <v-text-field
          v-model="asaasWalletId"
          :label="$t('partner.label.asaasWalletId')"
          :loading="isLoading"
          hide-details="auto"
          outlined
        />

        <v-spacer class="my-4" />

        <div class="d-flex align-center">
          <v-text-field
            v-model="historyEmail"
            :label="$t('partner.label.historyEmail')"
            :loading="isLoading"
            hide-details="auto"
            :rules="rules.nonRequiredEmailRule"
            outlined
            class="mr-4"
          />
          <InformationTooltip :small="false" :message="$t('partner.label.historyEmailHint')" />
        </div>

        <v-spacer class="my-8" />

        <h3 class="mb-4">{{ $t('customer.create.logo') }}</h3>

        <p v-show="partnerLogo" class="partnerLogoWrapper text-center lighten-4 grey pa-5">
          <img ref="partnerLogo" width="200" src="#" />
        </p>
        <HUpload @change="handlePartnerLogo" fileTypes="image/png, image/gif, image/jpeg, image/jpg" small />
      </v-form>
    </template>
    <template v-slot:actions>
      <v-btn
        @click="closeAllModals"
        :disabled="isLoading"
        elevation="0"
        class="mr-5"
        large
        text
      >
        {{ $t('partner.action.cancel') }}
      </v-btn>

      <v-btn
        @click="createUpdate"
        :loading="isLoading"
        :disabled="!valid"
        color="primary"
        elevation="0"
        large
      >
        {{ $t('partner.action.save') }}
      </v-btn>
    </template>
  </Modal>
</template>

<script>
import { mapActions, mapMutations, mapGetters } from 'vuex'
import { required, nonRequiredEmailRule } from '@/util/defaultValidationRules'

import Modal from '@/components/app/Modal'
import HUpload from '@/components/lib/HUpload'
import InformationTooltip from '../../../components/app/InformationTooltip.vue';

export default {
  name: 'PartnerCreateUpdate',

  components: {
    Modal,
    HUpload,
    InformationTooltip,
  },

  data() {
    return {
      id: null,
      name: null,
      description: null,
      asaasWalletId: null,
      historyEmail: null,
      valid: false,

      rules: {
        required,
        nonRequiredEmailRule
      },

      partnerLogo: null,
    }
  },

  watch: {
    partner(partner) {
      Promise.resolve(partner)
        .then(() => {
          const currentId = partner?.id

          if (currentId) this.fillPartnerFields()
          else this.resetFields()
        })
        .then(() => {
          return this.$refs?.partnerNameInput?.$el?.querySelector('input')
        })
        .then((input) => input?.focus())
    },
  },

  computed: {
    ...mapGetters(['partner', 'isLoading']),

    title() {
      return this.partner && this.partner.id
        ? this.$t('partner.action.update')
        : this.$t('partner.action.create')
    },
  },

  methods: {
    ...mapMutations(['closeAllModals']),
    ...mapActions([
      'createUpdatePartner',
    ]),

    createUpdate() {
      if (this.$refs.partnerForm.validate()) {
        const partner = {
          id: this.id ? this.id : null,
          name: this.name,
          description: this.description,
          asaas_wallet_id: this.asaasWalletId,
          history_email: this.historyEmail,
          logo: this.partnerLogo,
        }

        this.createUpdatePartner(partner)
      }
    },

    fillPartnerFields() {
      Promise.resolve(this.partner)
        .then(() => {
          this.id = this.partner ? this.partner.id : null
          this.name = this.partner ? this.partner.name : null
          this.description = this.partner ? this.partner.description : null
          this.asaasWalletId = this.partner ? this.partner.asaas_wallet_id : null
          this.historyEmail = this.partner ? this.partner.history_email : null
          this.partnerLogo = this.partner ? this.partner?.logo?.url : null
        })
        .then(() => this.setPartnerLogo())
    },

    resetFields() {
      this.id = null
      this.name = null
      this.asaasWalletId = null
      this.description = null
      this.partnerLogo = null
      this.historyEmail = null

      this.$nextTick(() => {
        this.$refs.partnerForm && this.$refs.partnerForm.resetValidation()
      })
    },

    handlePartnerLogo(file) {
      this.partnerLogo = file[0]
      const logoImg = this.$refs.partnerLogo

      if (this.partnerLogo) {
        const reader = new FileReader()
        reader.onload = (event) => logoImg.src = event.target.result
        reader.readAsDataURL(this.partnerLogo)
      }
    },

    setPartnerLogo() {
      const logoImg = this.$refs.partnerLogo

      if (this.partnerLogo) {
        if (typeof this.partnerLogo === 'string') {
          logoImg.src = this.partnerLogo
          return
        }
      }
    }
  },
}
</script>

<style>
.partnerLogoWrapper {
  border-radius: 6px;
}
</style>
